import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=8f9c6344"
import script from "./ActionDetail.vue?vue&type=script&lang=js"
export * from "./ActionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports